// import React, { useEffect, useRef, useState } from "react";
// import Styles from "../../styles/session/createsession.module.scss";
// import Navbar from "../../components/Navbar";
// import "react-quill/dist/quill.snow.css";
// import ReactQuill from "react-quill";
// import "../../styles/session/quill-custom.css";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { adminRoutes } from "../../routers/AdminRouters";
// import { addSession, editSession, getSessionById } from "../../services";
// import Close_Button from "../../assets/auth/close.png";
// import Suceess from "../../assets/session/success.png";
// import Swal from "sweetalert2";
// import { useDispatch, useSelector } from "react-redux";
// import { toggle } from "../../redux";
// function hhmmssToSeconds(time) {
//   const [hours, minutes, seconds] = time.split(":").map(Number);
//   return (hours * 3600) + (minutes * 60) + seconds;
// }

// function secondsToHhmmss(totalSeconds) {
//   const hours = Math.floor(totalSeconds / 3600);
//   const minutes = Math.floor((totalSeconds % 3600) / 60);
//   const seconds = totalSeconds % 60;
//   return [hours, minutes, seconds]
//     .map((unit) => String(unit).padStart(2, "0"))
//     .join(":");
// }

// const EditSession = () => {
//   const sessionName = useRef();
//   const { sessionId } = useParams();
//   const isSidebarOpen = useSelector((state) => state.navbar.button);
//   const dispatch = useDispatch();
//   const hoursRef = useRef(null);
//   const minutesRef = useRef(null);
//   const secondsRef = useRef(null);
//   const [secondPagePreview, setSecondPagePreview] = useState("");
//   const [thankYouPagePreview, setThankYouPagePreview] = useState("");
//   const [warmUp,setWarmUp]=useState("")
//   const navigate = useNavigate();
//   const handleSecondPageChange = (value) => {
//     setSecondPagePreview(value);
//   };
//   const handleMainContainerClick = () => {
//     if (isSidebarOpen) {
//       dispatch(toggle());
//     }
//   };

//   const handleThankYouPageChange = (value) => {
//     setThankYouPagePreview(value);
//   };

//   useEffect(() => {
//     const fetchSession = async () => {
//       try {
//         const response = await getSessionById(sessionId);
//         if (response) {
//           sessionName.current.value = response.name;
//           setSecondPagePreview(response.details);
//           setThankYouPagePreview(response.thankyou);

//         }
//       } catch (error) {
//         console.error("Error fetching session details:", error);
//       }
//     };

//     if (sessionId) {
//       fetchSession();
//     }
//   }, [sessionId]);
//  const handleTimeChange = () => {
//     const hours = hoursRef.current?.value.padStart(2, "0") || "00";
//     const minutes = minutesRef.current?.value.padStart(2, "0") || "00";
//     const seconds = secondsRef.current?.value.padStart(2, "0") || "00";

//     const newTimeInSeconds = hhmmssToSeconds(`${hours}:${minutes}:${seconds}`);

//     setTime(newTimeInSeconds);

//     setExerciseDetails((prev) => ({
//       ...prev,
//       time: newTimeInSeconds,
//     }));
//   };
//   const handleSubmit = async () => {
//     try {
//       const sessionData = {
//         name: sessionName.current.value,
//         details: secondPagePreview,
//         thankyou: thankYouPagePreview,
//       };

//       const success = await editSession(sessionId, sessionData);

//       if (success) {
//         Swal.fire({
//           html: `
//             <div style="text-align: center; border-radius: 20px; position: relative;">
//              <button
//                 id="customCloseButton"
//                 style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
//                 <img
//                 src=${Close_Button}
//                   alt="Close"
//                   style="width: 50px; height: 50px;"
//                 />
//               </button>
//               <img
//                 src=${Suceess}
//                 alt="Success"
//                 style="width: 100px; margin-bottom: 20px;margin-top:30px;"
//               />

//             <p style="color: #151515; text-align:center; font-family:gothambold; font-size:24px;">
//                Sessions Successfully Edited
//               </p>
//               <button
//                 id="assignformat"
//                 style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 15px 20px; font-family:gothambold; border: none; border-radius: 8px; cursor: pointer; margin-top: 20px;width:250px;height:48px;">
// Assign Format
//   </button>
//   <br/>
//             <button
//                 id="later"
//   style="background: white; color: #151515;  padding: 15px 20px; font-family:gothambold; border-radius: 8px; cursor: pointer; margin-top: 20px;border: 1px solid #E27808;width:250px;height:48px;font-size:14px;">
// Later  </button>
//             </div>
//           `,
//           showConfirmButton: false,
//           customClass: {
//             popup: "custom-swal-container",
//           },
//           didOpen: () => {
//             const assignformat = document.getElementById("assignformat");
//             const later = document.getElementById("later");
//             const closeButton = document.getElementById("customCloseButton");

//             assignformat.addEventListener("click", () => {
//               Swal.close();
//               navigate();
//             });

//             later.addEventListener("click", () => {
//               Swal.close();
//               navigate(adminRoutes.listSession);
//             });

//             closeButton.addEventListener("click", () => {
//               Swal.close();
//             });
//           },
//         });
//       }
//     } catch (error) {
//       console.error("Error submitting client:", error);
//     }
//   };
//   const handleBack = () => {
//     navigate(adminRoutes.listSession);
//   };
//   return (
//     <>
//       <Navbar />
//       <div
//         className={Styles.createsession_main}
//         onClick={handleMainContainerClick}
//       >
//         <h2>
//           <Link to={adminRoutes.dashboard} className={Styles.dark}>
//             HOME
//           </Link>{" "}
//           /
//           <Link to={adminRoutes.listSession} className={Styles.white}>
//             ALL SESSIONS
//           </Link>{" "}
//           /<span className={Styles.orange}>EDIT SESSIONS</span>
//         </h2>
//         <div className={Styles.createsession_container}>
//           <div className={Styles.createsession}>
//             <div className={Styles.createsession_container_heading}>
//               <h3>EDIT SESSION</h3>
//             </div>

//             <hr />
//             <div className={Styles.createsession_form_container}>
//               <form autoComplete="">
//                 <div className={Styles.createsession_form}>
//                   <div className={Styles.createsession_form_containerone}>
//                     <label className={Styles.label}>Session Name</label>
//                     <input
//                       placeholder="Enter here"
//                       required
//                       type="text"
//                       name="sessionname"
//                       ref={sessionName}
//                     />
//                   </div>

//               <div className={Styles.input_group}>
//                 <label>Time</label>
//                 <div className={Styles.time_field}>
//                   <span className={Styles.icon}>
//                     <svg
//                       width="25"
//                       height="25"
//                       viewBox="0 0 25 24"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z"
//                         stroke="#808080"
//                         stroke-width="1.5"
//                       />
//                       <path
//                         d="M12.333 8V12L14.333 14"
//                         stroke="#808080"
//                         stroke-width="1.5"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                     </svg>
//                   </span>
//                   <input
//                     type="text"
//                     placeholder="00"
//                     maxLength={2}
//                     className={Styles.time_input}
//                     ref={hoursRef}
//                     defaultValue={
//                       secondsToHhmmss(exerciseDetails.time).split(":")[0] ||
//                       "00"
//                     }
//                     onChange={handleTimeChange}
//                   />
//                   <input
//                     type="text"
//                     placeholder="00"
//                     maxLength={2}
//                     className={Styles.time_input}
//                     ref={minutesRef}
//                     defaultValue={
//                       secondsToHhmmss(exerciseDetails.time).split(":")[1] ||
//                       "00"
//                     }
//                     onChange={handleTimeChange}
//                   />
//                   <input
//                     type="text"
//                     placeholder="00"
//                     maxLength={2}
//                     className={Styles.time_input}
//                     ref={secondsRef}
//                     defaultValue={
//                       secondsToHhmmss(exerciseDetails.time).split(":")[2] ||
//                       "00"
//                     }
//                     onChange={handleTimeChange}
//                   />
//                 </div>
//               </div>
//                   <div className={Styles.createsession_form_containertwo}>
//                     <label className={Styles.label}>
//                       Second Page Preview Details
//                     </label>
//                     <div className="first-quill">
//                       <ReactQuill
//                         theme="snow"
//                         placeholder="Enter here..."
//                         value={secondPagePreview}
//                         onChange={handleSecondPageChange}
//                         className={Styles.customQuill}
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className={Styles.createsession_form_containerright}>
//                   <label className={Styles.label}>
//                     Thank You Page Preview Details
//                   </label>
//                   <div className="second-quill">
//                     <ReactQuill
//                       theme="snow"
//                       placeholder="Enter here..."
//                       value={thankYouPagePreview}
//                       onChange={handleThankYouPageChange}
//                       className={Styles.customQuill}
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//             <hr />
//             <div className={Styles.button_container}>
//               <div
//                 className={Styles.save}
//                 onClick={handleSubmit}
//                 style={{ cursor: "pointer" }}
//               >
//                 Save
//               </div>
//               <div
//                 className={Styles.cancel}
//                 onClick={handleBack}
//                 style={{ cursor: "pointer" }}
//               >
//                 Cancel
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default EditSession;

import React, { useEffect, useRef, useState } from "react";
import Styles from "../../styles/session/createsession.module.scss";
import Navbar from "../../components/Navbar";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import "../../styles/session/quill-custom.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { addSession, editSession, getSessionById } from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/success.png";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { toggle } from "../../redux";
import { toast } from "react-toastify";

function hhmmssToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const EditSession = () => {
  const sessionName = useRef();
  const { sessionId } = useParams();
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const dispatch = useDispatch();
  const [secondPagePreview, setSecondPagePreview] = useState("");
  const [thankYouPagePreview, setThankYouPagePreview] = useState("");
  const [hours, setHours] = useState("00");
  const [minutes, setMinutes] = useState("00");
  const [seconds, setSeconds] = useState("00");
  const [sessionDetails, setSessionDetails] = useState({ warmupTime: 0 });

  const navigate = useNavigate();

  const handleSecondPageChange = (value) => {
    setSecondPagePreview(value);
  };

  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  const handleThankYouPageChange = (value) => {
    setThankYouPagePreview(value);
  };

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await getSessionById(sessionId);
        if (response) {
          sessionName.current.value = response.name;
          setSecondPagePreview(response.details);
          setThankYouPagePreview(response.thankyou);
          setSessionDetails({ warmupTime: response.warmupTime });

          const [hh, mm, ss] = secondsToHhmmss(response.warmupTime).split(":");
          setHours(hh);
          setMinutes(mm);
          setSeconds(ss);
        }
      } catch (error) {
        console.error("Error fetching session details:", error);
      }
    };

    if (sessionId) {
      fetchSession();
    }
  }, [sessionId]);
  const handleTimeChange = () => {
    const newTimeInSeconds = hhmmssToSeconds(`${hours}:${minutes}:${seconds}`);
    setSessionDetails((prev) => ({
      ...prev,
      warmupTime: newTimeInSeconds,
    }));
  };

  const handleSubmit = async () => {
    try {
      if (sessionName.current.value.trim().length < 3) {
        toast.error("Session name must be at least 3 characters long.");

        return;
      }

      const sessionData = {
        name: sessionName.current.value,
        details: secondPagePreview,
        thankyou: thankYouPagePreview,
        // Use warmupTime from sessionDetails
        warmupTime: sessionDetails.warmupTime,
      };

      const success = await editSession(sessionId, sessionData);

      if (success) {
        Swal.fire({
          html: `
            <div style="text-align: center; border-radius: 20px; position: relative;">
              <button 
                id="customCloseButton" 
                style="position: absolute; top:-10px; right:-20px; background: none; border: none; cursor: pointer;">
                <img 
                  src=${Close_Button} 
                  alt="Close" 
                  style="width: 50px; height: 50px;"
                />
              </button>
              <img 
                src=${Suceess} 
                alt="Success" 
                style="width: 100px; margin-bottom: 20px; margin-top:30px;" 
              />
              <p style="color: #151515; text-align:center; font-family:gothambold; font-size:24px;">
                Sessions Successfully Edited
              </p>
              <button 
                id="assignformat" 
                style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 15px 20px; font-family:gothambold; border: none; border-radius: 8px; cursor: pointer; margin-top: 20px; width:250px; height:48px;">
                Assign Format            
              </button>
              <br/>
              <button 
                id="later" 
                style="background: white; color: #151515; padding: 15px 20px; font-family:gothambold; border-radius: 8px; cursor: pointer; margin-top: 20px; border: 1px solid #E27808; width:250px; height:48px; font-size:14px;">
                Later  
              </button>
            </div>
          `,
          showConfirmButton: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const assignformat = document.getElementById("assignformat");
            const later = document.getElementById("later");
            const closeButton = document.getElementById("customCloseButton");

            assignformat.addEventListener("click", () => {
              Swal.close();
              navigate(adminRoutes.listFormat.replace(":sessionId", sessionId));
            });

            later.addEventListener("click", () => {
              Swal.close();
              navigate(adminRoutes.listSession);
            });

            closeButton.addEventListener("click", () => {
              Swal.close();
            });
          },
        });
      }
    } catch (error) {
      console.error("Error submitting session:", error);
    }
  };

  const handleBack = () => {
    navigate(adminRoutes.listSession);
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.createsession_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.dashboard} className={Styles.dark}>
            HOME
          </Link>{" "}
          /
          <Link to={adminRoutes.listSession} className={Styles.white}>
            ALL SESSIONS
          </Link>{" "}
          /<span className={Styles.orange}>EDIT SESSIONS</span>
        </h2>
        <div className={Styles.createsession_container}>
          <div className={Styles.createsession}>
            <div className={Styles.createsession_container_heading}>
              <h3>EDIT SESSION</h3>
            </div>

            <hr />
            <div className={Styles.createsession_form_container}>
              <form autoComplete="">
                <div className={Styles.createsession_form}>
                  <div className={Styles.createsession_form_containerone}>
                    <label className={Styles.label}>Session Name</label>
                    <input
                      placeholder="Enter here"
                      required
                      type="text"
                      name="sessionname"
                      ref={sessionName}
                    />
                  </div>

                  <div className={Styles.createsession_form_containertwo}>
                    <label className={Styles.label}>Warm Up</label>
                    <div className={Styles.time_field}>
                      <span className={Styles.icon}>
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z"
                            stroke="#808080"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M12.333 8V12L14.333 14"
                            stroke="#808080"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <input
                        type="text"
                        maxLength={2}
                        className={Styles.time_input}
                        value={hours}
                        onChange={(e) => setHours(e.target.value)}
                        onBlur={handleTimeChange}
                        onKeyDown={(e) => {
                          if (e.key === "-") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <span className={Styles.separator}>:</span>

                      <input
                        type="text"
                        maxLength={2}
                        className={Styles.time_input}
                        value={minutes}
                        onChange={(e) => setMinutes(e.target.value)}
                        onBlur={handleTimeChange}
                        onKeyDown={(e) => {
                          if (e.key === "-") {
                            e.preventDefault();
                          }
                        }}
                      />
                      <span className={Styles.separator}>:</span>

                      <input
                        type="text"
                        maxLength={2}
                        className={Styles.time_input}
                        value={seconds}
                        onChange={(e) => setSeconds(e.target.value)}
                        onBlur={handleTimeChange}
                        onKeyDown={(e) => {
                          if (e.key === "-") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className={Styles.createsession_form_containertwo}>
                    <label className={Styles.label}>
                      Second Page Preview Details
                    </label>
                    <div className="first-quill">
                      <ReactQuill
                        theme="snow"
                        placeholder="Enter here..."
                        value={secondPagePreview}
                        onChange={handleSecondPageChange}
                        className={Styles.customQuill}
                      />
                    </div>
                  </div>
                </div>

                <div className={Styles.createsession_form_containerright}>
                  <label className={Styles.label}>
                    Thank You Page Preview Details
                  </label>
                  <div className="second-quill">
                    <ReactQuill
                      theme="snow"
                      placeholder="Enter here..."
                      value={thankYouPagePreview}
                      onChange={handleThankYouPageChange}
                      className={Styles.customQuill}
                    />
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div className={Styles.button_container}>
              <div
                className={Styles.save}
                onClick={handleSubmit}
                style={{ cursor: "pointer" }}
              >
                Save
              </div>
              <div
                className={Styles.cancel}
                onClick={handleBack}
                style={{ cursor: "pointer" }}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSession;
